import ListCellZ from "../../atoms/ListCellZ";
import CenterTitleZ from "../../atoms/CenterTitleZ";
import Buttonz from "../../atoms/Buttonz";
import { logout as pbLogout } from "../../../auth/authApi";

function SettingCenterBar({ activeSection, handleSectionChange, title, icon }) {
  return (
    <>
      <CenterTitleZ title={title} icon={icon} />

      <div className="list-cell-box">
        <ListCellZ
          text="Profile"
          icon="namecard"
          iconRight={activeSection === "profile" ? "ok" : ""}
          onClick={() => handleSectionChange("profile")}
          selected={activeSection === "profile"}
        />
        <ListCellZ
          text="Email Address"
          icon="mail"
          iconRight={activeSection === "email" ? "ok" : ""}
          onClick={() => handleSectionChange("email")}
          selected={activeSection === "email"}
        />
        <ListCellZ
          text="Password"
          icon="password"
          iconRight={activeSection === "password" ? "ok" : ""}
          onClick={() => handleSectionChange("password")}
          selected={activeSection === "password"}
        />
        <ListCellZ
          text="Account"
          icon="account"
          iconRight={activeSection === "account" ? "ok" : ""}
          onClick={() => handleSectionChange("account")}
          selected={activeSection === "account"}
        />
      </div>

      <Buttonz
        iconR="logout"
        onClick={() => {
          pbLogout();
          window.location.reload();
        }}
        label="Logout"
        className="logout-btn"
      />
    </>
  );
}

export default SettingCenterBar;
